import { SupportTicket } from '@zenstackhq/runtime/models'
import { message } from 'antd'
import { OrganizationMemberFromContext } from '~/core/context/organization/hooks/useOrganizationMembers'
import { Api } from '~/core/trpc'

type Props = {
  ticket: SupportTicket
  organizationMemberAgent: OrganizationMemberFromContext
}

export const useLogic = ({ ticket, organizationMemberAgent }: Props) => {
  const triggerEventMutation = Api.dataConnector.triggerEvent.useMutation()

  const triggerHttpEvent = async (eventKey: string, payload: any = {}) => {
    await triggerEventMutation.mutateAsync({
      appId: organizationMemberAgent.appSession.appId,
      providerKey: 'http',
      providerTriggerKey: 'NewRequest',
      appSessionId: organizationMemberAgent.appSession.id,
      payload: {
        eventKey,
        _version: 2,
        ...payload,
      },
    })
  }

  const updateQuery = Api.supportTicket.update.useMutation()

  const update = async (values: Partial<SupportTicket>) => {
    if (updateQuery.isLoading) {
      return
    }

    try {
      const ticketUpdated = await updateQuery.mutateAsync({
        where: {
          id: ticket.id,
        },
        data: {
          ...values,
        },
      })

      return ticketUpdated
    } catch (error) {
      message.error(`Something went wrong`)
      console.error('Unknown Error', error)
    }
  }

  const replyToQuestions = async (values: Partial<SupportTicket>) => {
    const ticketUpdated = await update(values)

    if (ticketUpdated) {
      await triggerHttpEvent('ticket.responses', { ticketId: ticketUpdated.id })
    }
  }

  return {
    update,
    replyToQuestions,
  }
}
